import React from 'react';
import SearchBar from "./SearchBar";
import NavIcon from "./NavIcon";
import Thumbnail from "./Thumbnail";
import Map from "./Map";
import MapModal from "./MapModal";
import Draggable from 'react-draggable';
import FilterDropDown from "./FilterDropDown";


class MapSidebar extends React.Component {

    state = {sidebarPos: {x: 0, y: 0} };

    _onControlledDrag = (e, position) => {
        const {deltaX, deltaY} = position;
        if (deltaY < 0) {
            let top_height = window.innerHeight-400;
            this.setState({sidebarPos: { x: 0, y: -top_height}});
        } else {
            this.setState({sidebarPos: { x: 0, y: 0}});
        }
    };

    componentDidUpdate()
    {
        if(this.props.selection) {
            if (this.state.sidebarPos.y !== 210) {
                this.setState({sidebarPos: { x: 0, y: 210 }})
            }
        } else {
            if (this.state.sidebarPos.y === 210) {
                this.setState({sidebarPos: { x: 0, y: 0 }})
            }
        }
    }

    getColor = (category) => {
        let icons = this.props.categories.filter((cat) => {
            if(cat.slug === category) {
                return true;
            }
        });

        return icons[0].color ?? "#838383";
    }

    render() {
        return (
            <React.Fragment>
            <Draggable
                axis="y"
                handle="#sidebar-handle"
                position={this.state.sidebarPos}
                onDrag={this._onControlledDrag}
            >
                <div id="map_sidebar" className="map-sidebar shadow-right">
                    <div id="sidebar-handle">
                        <i className="far fa-horizontal-rule"></i>
                    </div>
                    <div className="sidebar-body scrollbar-inner">
                        <div className="mb-gutter p-4">
{/*
                            <SearchBar search={(text) => this.props.search(text)} findSelection={(location, zoom) => this.props.findSelection(location, zoom)}/>
*/}

                            <nav className="nav flex-column justify-content-around text-sm text-center">
                                <NavIcon selected={this.props.active_category === null} icon="map-marker-alt" name="All" color="#838383" filterLocation={this.props.filterLocation} type={null}/>
                                {
                                    this.props.categories?.map((category, key) => (
                                        <NavIcon selected={this.props.active_category === category.slug} icon={category.icon} name={category.name} color={this.getColor(category.slug)} filterLocation={this.props.filterLocation} type={category.slug} count={category.count}/>
                                    ))
                                }
                            </nav>
                        </div>

                        {/*<div className="py-4">
                            {
                                this.props.locations.map((location, key) => {
                                    return (
                                        <Thumbnail
                                            key={key}
                                            location={location}
                                            updateSelection={(id) => this.props.updateSelection(id)}
                                            selected={this.props.selection ? this.props.selection.id === location.id: false}
                                        />
                                    )
                                })
                            }
                        </div>*/}
                    </div>
                </div>
            </Draggable>
                {
                    this.props.selection ?
                        <MapModal updateSelection={(id) => this.props.updateSelection(id)} location={this.props.selection}/>
                        :
                        null
                }
            </React.Fragment>
        )
    }
}

export default MapSidebar;
